import { useQuery } from "@tanstack/react-query";
import { api } from "../../../services/api/axios";

// Payouts that failed or were refunded, newest first.
const fetchFailedPayouts = async ({ page, limit, search }) => {
  const response = await api.get("/v1/admin/personal/failed-payouts", {
    params: { page, limit, ...(search && { search }) },
  });
  return response.data;
};

export const useFailedPayouts = (page = 1, limit = 10, search = "") => {
  return useQuery({
    queryKey: ["failed-payouts", page, limit, search],
    queryFn: () => fetchFailedPayouts({ page, limit, search }),
    refetchOnWindowFocus: false,
  });
};
